import { FullScreenLoaderService } from '@adnoc/servicebox';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { UserMappingService } from '../../services/user-mapping.service';
import { ToastrService } from 'ngx-toastr';
import { reject } from 'lodash-es';
import { ButtonType, ButtonVariant } from '@adnoc/onehub-form-ui';

@UntilDestroy()
@Component({
  selector: 'app-user-mapping',
  templateUrl: './user-mapping.component.html',
  styleUrls: ['./user-mapping.component.scss'],
})
export class UserMappingComponent implements OnInit {
  form: FormGroup<{ targetEmployee: FormControl<string> }>;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userMappingService: UserMappingService,
    private changeDetectorRef: ChangeDetectorRef,
    private fullScreenLoaderService: FullScreenLoaderService,
    private toastrService: ToastrService
  ) {
    this.form = this.formBuilder.group({
      targetEmployee: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.loadCurrentMapping();
  }

  onSubmit(): void {
    debugger;
    if (!this.form.value.targetEmployee) {
      return;
    }

    this.fullScreenLoaderService.show();
    this.userMappingService
      .changeMapping$(this.form.value.targetEmployee.trim())
      .pipe(
        finalize(() => {
          this.fullScreenLoaderService.hide();
          this.changeDetectorRef.markForCheck();
        }),
        untilDestroyed(this)
      )
      .subscribe({
        next: () => {
          this.toastrService.success(
            `Mapping set successfully to ${this.form.value.targetEmployee}`
          );
        },
        error: () => {
          this.toastrService.error('Failed to set a mapping');
        },
      });
  }

  onDelete(): void {
    debugger;
    this.deleteMapping();
  }

  private loadCurrentMapping(): void {
    this.fullScreenLoaderService.show();
    this.userMappingService
      .getCurrentMapping$()
      .pipe(
        finalize(() => {
          this.changeDetectorRef.markForCheck();
          this.fullScreenLoaderService.hide();
        }),
        untilDestroyed(this)
      )
      .subscribe({
        next: (emailMapping) => {
          this.form.patchValue({ targetEmployee: emailMapping?.mappedEmail });
        },
        error: () => {
          this.toastrService.error('Failed to load current mapping');
        },
      });
  }

  private deleteMapping(): void {
    this.fullScreenLoaderService.show();
    this.userMappingService
      .deleteMapping$()
      .pipe(
        switchMap(() => this.userMappingService.getCurrentMapping$()),
        finalize(() => {
          this.fullScreenLoaderService.hide();
          this.changeDetectorRef.markForCheck();
        }),
        untilDestroyed(this)
      )
      .subscribe({
        next: (emailMapping) => {
          this.form.patchValue({ targetEmployee: emailMapping?.mappedEmail });
          this.toastrService.success('Mapping deleted successfully');
        },
        error: () => {
          this.toastrService.error('Failed to delete mapping');
        },
      });
  }

  protected readonly reject = reject;
  protected readonly ButtonType = ButtonType;
  protected readonly ButtonVariant = ButtonVariant;
}
